export const tags = [
  { id: 1, name: "All", selected: false },
  { id: 2, name: "Swedish", selected: false },
  { id: 3, name: "Hot stone", selected: false },
  { id: 4, name: "Aromatherapy", selected: false },
  { id: 5, name: "Deep tissue", selected: false },
  { id: 6, name: "Sports", selected: false },
  { id: 7, name: "Trigger point", selected: false },
  { id: 8, name: "Reflexology", selected: false },
  { id: 9, name: "Shiatsu", selected: false },
  { id: 10, name: "Thai", selected: false },
  { id: 11, name: "Prenatal", selected: false },
];
